import i18n from '@/i18n'
import gtag from '../lib/gtag'

export default function (store, router) {
  async function beforeEachHook(to, from, next) {
    // change document.title
    document.title = i18n.t(`document.title.${to.name}`) + ' - Filios'

    // Initial logged state
    if (store.state.logged === null) {
      await store.dispatch('INIT')
    }

    // Redirect to non auth route
    if (
      store.state.logged === false &&
      to.matched.some((route) => route.meta.requiredAuth === true)
    ) {
      next(false)
      router.replace({ name: 'login' })
      return
    }

    // Redirect to auth route
    if (
      store.state.logged === true &&
      to.matched.some((route) => route.meta.requiredAuth === false)
    ) {
      next(false)
      router.replace({ name: 'portfolio' })
      return
    }
    next()
  }

  async function afterEachHook(to, from, next) {
    if (
      ['portfolio', 'input', 'tax', 'watchList', 'myAccount', 'dashboardDetail'].indexOf(
        to.name
      ) === -1
    )
      // excluded pages gtagged inside with filters, tabs etc
      gtag.pageview({
        pagePath: `/${to.name}`,
        pageTitle: `${to.name}`,
        pageContentGroup: 'page',
      })
  }

  // Watch for logged changes
  store.watch(
    (state) => state.logged,
    (curr, prev) => {
      if (prev !== null) {
        beforeEachHook(router.currentRoute, null, () => {})
      }
    }
  )

  router.beforeEach(beforeEachHook)
  router.afterEach(afterEachHook)
}
